import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  fieldWrapper: {
    marginBottom: '16px',
  },
  fieldLabel: {
    display: 'block',
    marginBottom: '4px',
  },
  textInput: {
    width: '100%',
    padding: '8px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    fontSize: '14px',
    boxSizing: 'border-box',
  },
  textarea: {
    width: '100%',
    padding: '8px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    fontSize: '14px',
    boxSizing: 'border-box',
    resize: 'vertical',
  },
})

export { useStyles }
